/**
 * Created by olga on 04.07.2025
 */

const SoonComponent = function (unit) {
    UnitComponent.call(this, unit);
};

SoonComponent.prototype = Object.create(UnitComponent.prototype);
SoonComponent.prototype.constructor = SoonComponent;

SoonComponent.prototype.handleClick = function () {
    cleverapps.focusManager.display({
        focus: "moveNext",
        actions: [
            function (f) {
                new AllDoneWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }]
    });
};
